import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexGrow: 1,

    '& .logo': {
      width: '100%',
      maxWidth: 210,
      maxHeight: 120,
      margin: theme.spacing(0, 0, 5, 0),
      objectFit: 'contain',
    },
    '& .loading-bar': {
      width: '100%',
      maxWidth: 80,
    },
  },
}));

export default styles;
